import { Banner, BannerCollapseButton } from 'flowbite-react';
import { useState } from 'react';
import { HiLightBulb, HiX } from 'react-icons/hi';

const BANNER_HIDDEN_KEY = 'campaign_planner_explanation_banner_hidden';

export const useExplanationBanner = () => {
    const [isVisible, setIsVisible] = useState(() => {
        if (typeof window !== 'undefined') {
            return !localStorage.getItem(BANNER_HIDDEN_KEY);
        }
        return false;
    });

    const hide = () => {
        setIsVisible(false);
        localStorage.setItem(BANNER_HIDDEN_KEY, 'true');
    };

    const show = () => {
        setIsVisible(true);
        localStorage.removeItem(BANNER_HIDDEN_KEY);
    };

    return { isVisible, hide, show };
};

interface ShowExplanationButtonProps {
    onClick: () => void;
}

export const ShowExplanationButton = ({
    onClick,
}: ShowExplanationButtonProps) => (
    <button
        type="button"
        onClick={onClick}
        title="Show campaign planner tips"
        aria-label="Show campaign planner tips"
        className="inline-flex items-center gap-2 h-10 px-3 rounded-lg glass text-white hover:text-accent cursor-pointer transition-colors"
    >
        <HiLightBulb className="w-5 h-5" />
        <span className="text-sm">Show tips</span>
    </button>
);

interface ExplanationBannerProps {
    length: number;
    onClose: () => void;
}

export const ExplanationBanner = ({
    length,
    onClose,
}: ExplanationBannerProps) => {
    return (
        <Banner className="bg-linear-to-r from-blue-100 to-indigo-400 border border-blue-200 rounded-lg p-6">
            <div className="flex items-start gap-4">
                <div className="shrink-0">
                    <div className="w-12 h-12 rounded-full bg-blue-200 flex items-center justify-center">
                        <HiLightBulb className="w-6 h-6 text-blue-600" />
                    </div>
                </div>
                <div className="flex-1 space-y-3">
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                            Campaign Planner
                        </h3>
                        <p className="text-gray-700 leading-relaxed">
                            Plan and organize your marketing campaigns
                            effectively. Set budgets, define timeframes, and
                            configure rules to optimize your campaign
                            performance.
                            {length > 0 && (
                                <span className="font-medium">
                                    {' '}
                                    Continue working on your existing campaigns
                                    below or create a new one to expand your
                                    marketing strategy.
                                </span>
                            )}
                        </p>
                    </div>
                    <div className="flex items-center gap-4">
                        <span className="text-sm text-gray-600">
                            {length} active{' '}
                            {length === 1 ? 'campaign' : 'campaigns'}
                        </span>
                    </div>
                </div>

                <BannerCollapseButton
                    color="gray"
                    className="glass cursor-pointer"
                    onClick={onClose}
                >
                    <HiX className="h-4 w-4" />
                </BannerCollapseButton>
            </div>
        </Banner>
    );
};
